import React from 'react'
import Link from 'next/link'
import {handleButtonClass} from "./button.base";

function ButtonLink(props) {
    const classes = handleButtonClass(props);
    const {href, hrefAs, children} = props;

    return (
        <Link href={href} as={hrefAs}>
			<a ref={props.buttonRef} className={classes} id={props.id ?? ''}>
				{children}
			</a>
        </Link>
    );
}


export default React.memo(ButtonLink);